/**
 * Récemment consultés RAWNAQ.
 * - Mémorise les produits vus (clé « rawnaqViewed », 12 max) et reprend aussi ceux d'Horizon (« viewedProducts »).
 * - Charge les cartes via /search?q=id:… OR id:…&section_id=… et les remet dans l'ordre de consultation.
 * - Exclut le produit en cours de consultation.
 */
const KEY = 'rawnaqViewed';
const MAX = 12;

function read(key) {
  try {
    return JSON.parse(localStorage.getItem(key) || '[]').map(String);
  } catch (error) {
    return [];
  }
}

function remember(id) {
  if (!id) return;
  const list = [String(id), ...read(KEY).filter((item) => item !== String(id))].slice(0, MAX);
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch (error) {
    /* stockage indisponible : on ignore */
  }
}

class RawnaqRecentlyViewed extends HTMLElement {
  connectedCallback() {
    const current = this.dataset.current || '';
    const limit = Number(this.dataset.limit) || 8;
    const ids = [...new Set([...read(KEY), ...read('viewedProducts')])].filter((id) => id && id !== current).slice(0, limit);

    remember(current);

    if (!ids.length) {
      this.hidden = true;
      return;
    }
    this.#load(ids);
  }

  async #load(ids) {
    const url = new URL(this.dataset.url || '/search', location.origin);
    url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('section_id', this.dataset.sectionId);

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(String(response.status));
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const cards = [...doc.querySelectorAll('[data-rv-grid] .rq-rv__card')];
      cards.sort((a, b) => ids.indexOf(a.dataset.productId) - ids.indexOf(b.dataset.productId));

      const grid = this.querySelector('[data-rv-grid]');
      grid?.replaceChildren(...cards.map((card) => document.importNode(card, true)));
      this.hidden = !cards.length;
    } catch (error) {
      this.hidden = true;
    }
  }
}

if (!customElements.get('rawnaq-recently-viewed')) {
  customElements.define('rawnaq-recently-viewed', RawnaqRecentlyViewed);
}
